module.exports = __webpack_public_path__ + "img/sunrise.2298284e.svg";